import { useCallback, useRef, useState } from "react";
import type { MutableRefObject } from "react";
import { AdvancedVideo } from "@cloudinary/react";
import { trackVideoPause, trackVideoPlay } from "./track-video-events";

export const useVideoPlayer = () => {
  const videoEl = useRef(null) as MutableRefObject<AdvancedVideo | null>;
  const [isPlaying, setIsPlaying] = useState(true);

  const pauseVideo = useCallback(() => {
    const video = videoEl?.current?.htmlVideoLayerInstance?.videoElement;
    const videoSlug = video?.getAttribute("data-video-slug");
    video?.pause();
    setIsPlaying(false);
    trackVideoPause(video, videoSlug);
  }, [videoEl]);

  const playVideo = useCallback(() => {
    const video = videoEl?.current?.htmlVideoLayerInstance?.videoElement;
    const videoSlug = video?.getAttribute("data-video-slug");
    video?.play().then(() => setIsPlaying(true));
    trackVideoPlay(video, videoSlug);
  }, [videoEl]);

  const handleClick = () => {
    if (isPlaying) {
      pauseVideo();
    } else {
      playVideo();
    }
  };

  return {
    handleClick,
    videoEl,
    isPlaying,
    setIsPlaying,
  };
};
